import { render, staticRenderFns } from "./GCustomBoxplotSetting.vue?vue&type=template&id=641c6444&scoped=true&"
import script from "./GCustomBoxplotSetting.vue?vue&type=script&lang=ts&"
export * from "./GCustomBoxplotSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GCustomBoxplotSetting.vue?vue&type=style&index=0&id=641c6444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c6444",
  null
  
)

export default component.exports